import { module } from 'modujs'

export default class VideoPopup extends module {

    static ACTIVE_CLASS = 'is-active';
    static LOCAL_STORAGE_KEY = 'videoPopupClosed';

    constructor(m) {
        super(m)

        this.events = {
            click: {
                close: "close"
            }
        }
    }

    init() {
        const isPopupClosed = localStorage.getItem(VideoPopup.LOCAL_STORAGE_KEY);

        if (!isPopupClosed) {
            this.showPopup();
        }
    }

    close() {
        localStorage.setItem(VideoPopup.LOCAL_STORAGE_KEY, 'true');

        this.hidePopup();
    }

    showPopup() {
        this.el.classList.add(VideoPopup.ACTIVE_CLASS);
    }

    hidePopup() {
        this.el.classList.remove(VideoPopup.ACTIVE_CLASS);
    }
}
